// visit images
export const GET_VISIT_IMAGES_SUCCESS = 'GET_VISIT_IMAGES_SUCCESS';
export const GET_VISIT_IMAGES_FAILURE = 'GET_VISIT_IMAGES_FAILURE';
export const GET_VISIT_IMAGES_REQUEST = 'GET_VISIT_IMAGES_REQUEST';
export const CLEAR_VISIT_IMAGES = 'CLEAR_VISIT_IMAGES';

// visit image
export const SELECT_VISIT_IMAGE = 'SELECT_VISIT_IMAGE';
export const CLEAR_SELECTED_VISIT_IMAGE = 'CLEAR_SELECTED_VISIT_IMAGE';
